import { API_CALL } from '../middleware/api';

export const CREATE_FILE_UPLOAD = 'create-file-upload';
export const COMPLETE_FILE_UPLOAD = 'complete-file-upload';
export const GET_STORAGE_FILES = 'get-storage-files';
export const PREVIEW_STORED_FILE = 'preview-stored-file';
export const DELETE_STORED_FILE = 'delete-stored-file';

export const fileActions = {
  createUpload: (file, purpose) => ({
    [API_CALL]: {
      endpoint: 'portal/files/uploads',
      method: 'POST',
      data: { purpose, file_name: file.name, mime_type: file.type, size_bytes: file.size },
    },
    type: CREATE_FILE_UPLOAD,
  }),
  completeUpload: (purpose, objectName) => ({
    [API_CALL]: {
      endpoint: 'portal/files/uploads/complete',
      method: 'POST',
      data: { purpose, object_name: objectName },
    },
    type: COMPLETE_FILE_UPLOAD,
  }),
  getStorageFiles: purpose => ({
    [API_CALL]: {
      endpoint: 'portal/files/storage',
      method: 'GET',
      params: { purpose },
    },
    type: GET_STORAGE_FILES,
  }),
  previewStoredFile: (purpose, objectName) => ({
    [API_CALL]: {
      endpoint: 'portal/files/storage/preview',
      method: 'GET',
      params: { purpose, object_name: objectName },
    },
    type: PREVIEW_STORED_FILE,
  }),
  deleteStoredFile: (purpose, objectName) => ({
    [API_CALL]: {
      endpoint: 'portal/files/storage',
      method: 'DELETE',
      params: { purpose, object_name: objectName },
    },
    type: DELETE_STORED_FILE,
  }),
};
